import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import * as S from "../../style/StyleComponentSection";
import * as U from "../../style/StyleComponentUtility";
import { get_day_timestamp } from "../../Validation";
import { cancel_reservation_one, get_select_one_reservation, update_reservation_site_photos } from "../../Axios";
import no_image from "../../assets/images/Group 72.svg";
import leftArrow from "../../assets/icons/stroke_left.svg";
import rightArrow from "../../assets/icons/stroke_right.svg";
import closeIcon from "../../assets/icons/close_30.svg";
import theme from "../../style/theme";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/Store";
import { useDispatch } from "react-redux";
import { reduxOffSpinner, reduxOnSpinner } from "../../redux/CommonSlice";
import { update_nav } from "../../Util";

const mainBlack = theme.colors.mainBlack;
const mainWhite = theme.colors.mainWhite;
const lightGray02 = theme.colors.lightGray02;

interface Reservation {
    construction_reservation_ID                : number;
    construction_reservation_progress          : number;
    construction_reservation_progress_name     : string;
    construction_reservation_division          : number;
    construction_reservation_division_name     : string;
    construction_reservation_name              : string;
    construction_reservation_big_area          : string;
    construction_reservation_small_area        : string;
    construction_reservation_before_big_area   : string;
    construction_reservation_before_small_area : string;
    construction_reservation_reservationTime   : any;
    construction_reservation_time_name         : string;
    construction_reservation_installation_date_format  : string;
    construction_reservation_installation_time_period  : string;
    construction_reservation_schedule_status_name      : string;
    construction_reservation_requests          : string;
    construction_reservation_point             : number;
    brand_kor_name                             : string;
    product_name                               : string;
    color_name                                 : string;
    construction_reservation_count             : number;
    construction_reservation_address           : string;
    construction_reservation_before_address    : string;
    construction_reservation_phone_number      : string;
    construction_reservation_pay               : number;
    construction_reservation_high_status_name  : string;
    construction_reservation_result_picture1   : string;
    construction_reservation_result_picture2   : string;
    construction_reservation_result_picture3   : string;
    construction_reservation_result_picture4   : string;
    construction_reservation_site_img_1        : string;
    construction_reservation_site_img_2        : string;
    construction_reservation_site_img_3        : string;
    construction_reservation_site_img_4        : string;
    construction_reservation_square_meter      : number;
    construction_reservation_square_meter_name : string;
    construction_reservation_space             : number;
    construction_reservation_space_name        : string;
};

const ReservationSelectOne:React.FC = () => {
    
    const {state} = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const customerData = useSelector((state: RootState) => state.customerData);
    const [reservationOne, setReservationOne] = useState<Reservation>();

    const [modal, setModal] = useState<boolean>(false);
    const [imageList, setImageList] = useState<any[]>([]);
    const [siteImageList, setSiteImageList] = useState<any[]>([]);
    const [bigImageSRC, setBigImageSRC] = useState<string>("");
    const [bigImageIndex, setBigImageIndex] = useState<number>(0);
    const [imageCategory, setImageCategory] = useState<number>(0);

    // 현장 사진 수정 (2026-10-28) — 유지 중인 기존 URL + 신규 파일을 들고 있다가 [저장] 한 번에 보낸다 (최대 4장, 2장 이상)
    const [siteEditMode, setSiteEditMode] = useState<boolean>(false);
    const [siteKeep, setSiteKeep] = useState<string[]>([]);
    const [siteNewFiles, setSiteNewFiles] = useState<File[]>([]);
    const [siteNewPreviews, setSiteNewPreviews] = useState<string[]>([]);
    const [siteSaving, setSiteSaving] = useState<boolean>(false);
    const SITE_PHOTO_MAX = 4;
    const SITE_PHOTO_MIN = 2;
    const siteActiveCount = siteKeep.length + siteNewFiles.length;
    // 시공 완료(4)·취소(5)는 수정 불가 — 취소하기 버튼과 같은 조건
    const canEditSite = reservationOne !== undefined
        && reservationOne.construction_reservation_progress !== 4
        && reservationOne.construction_reservation_progress !== 5;

    const loadReservation = () => {
        get_select_one_reservation(state.reservation_ID).then(result => {
            if (!result || !result.construction_reservation_ID) {
                alert('예약 정보를 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.');
                navigate(-1);
                return;
            }
            setReservationOne(result);
            let list = [];
            if(result.construction_reservation_progress === 4) {
                if(result.construction_reservation_result_picture1 !== null && result.construction_reservation_result_picture1 !== "") list.push(result.construction_reservation_result_picture1);
                if(result.construction_reservation_result_picture2 !== null && result.construction_reservation_result_picture2 !== "") list.push(result.construction_reservation_result_picture2);
                if(result.construction_reservation_result_picture3 !== null && result.construction_reservation_result_picture3 !== "") list.push(result.construction_reservation_result_picture3);
                if(result.construction_reservation_result_picture4 !== null && result.construction_reservation_result_picture4 !== "") list.push(result.construction_reservation_result_picture4);
            } else {
                if(result.construction_reservation_site_img_1 !== null && result.construction_reservation_site_img_1.length > 40) list.push(result.construction_reservation_site_img_1);
                if(result.construction_reservation_site_img_2 !== null && result.construction_reservation_site_img_2.length > 40) list.push(result.construction_reservation_site_img_2);
                if(result.construction_reservation_site_img_3 !== null && result.construction_reservation_site_img_3.length > 40) list.push(result.construction_reservation_site_img_3);
                if(result.construction_reservation_site_img_4 !== null && result.construction_reservation_site_img_4.length > 40) list.push(result.construction_reservation_site_img_4);
            }
            setImageList(list);
            let site_image_list = [];
            if (result.construction_reservation_site_img_1 !== null && result.construction_reservation_site_img_1 !== "") {
                site_image_list.push(result.construction_reservation_site_img_1);
            }
            if (result.construction_reservation_site_img_2 !== null && result.construction_reservation_site_img_2 !== "") {
                site_image_list.push(result.construction_reservation_site_img_2);
            }
            if (result.construction_reservation_site_img_3 !== null && result.construction_reservation_site_img_3 !== "") {
                site_image_list.push(result.construction_reservation_site_img_3);
            }
            if (result.construction_reservation_site_img_4 !== null && result.construction_reservation_site_img_4 !== "") {
                site_image_list.push(result.construction_reservation_site_img_4);
            }
            setSiteImageList(site_image_list);
        });
    };

    useEffect(() => {
        loadReservation();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state]);

    // 신규 파일 미리보기 — 바뀔 때마다 새로 만들고 이전 것은 해제
    useEffect(() => {
        const previews = siteNewFiles.map(file => URL.createObjectURL(file));
        setSiteNewPreviews(previews);
        return () => { previews.forEach(url => URL.revokeObjectURL(url)); };
    }, [siteNewFiles]);

    const startSiteEdit = () => {
        setSiteKeep(siteImageList);
        setSiteNewFiles([]);
        setSiteEditMode(true);
    };
    const cancelSiteEdit = () => {
        setSiteEditMode(false);
        setSiteKeep([]);
        setSiteNewFiles([]);
    };
    const addSiteFile = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files && e.target.files[0];
        if (file && siteActiveCount < SITE_PHOTO_MAX) setSiteNewFiles([...siteNewFiles, file]);
        e.target.value = '';
    };
    const saveSitePhotos = () => {
        if (siteSaving || !reservationOne) return;
        if (siteActiveCount < SITE_PHOTO_MIN) return alert(`현장 사진은 ${SITE_PHOTO_MIN}장 이상이어야 합니다.`);
        setSiteSaving(true);
        dispatch(reduxOnSpinner('사진을 저장하고 있습니다'));
        update_reservation_site_photos(
            reservationOne.construction_reservation_ID,
            customerData.customer_ID,
            siteKeep,
            siteNewFiles
        ).then(result => {
            dispatch(reduxOffSpinner());
            setSiteSaving(false);
            if (result && result.success === true) {
                alert('현장 사진이 저장되었습니다.');
                cancelSiteEdit();
                loadReservation();
            } else {
                alert((result && result.error) || '알 수 없는 오류입니다.');
            }
        });
    };

    useEffect(() => {
        if(modal) {
            document.body.classList.add('on-modal-back');
        } else {
            document.body.classList.remove('on-modal-back');
        }
    }, [modal]);

    return (
        <S.SectionContainer>
            <S.SectionWidth $width={900}>
                <U.BreakLine $height={60} />

                <S.ReservationSelectOneContainer>
                    <div>
                        <div className="content-title">
                            예약 상세 내역
                        </div>
                        <U.BreakLine $height={30} />
                        <S.SectionBorderContainer className="">
                            <div className="content-line">
                                <div className="label-box">진행상태</div>
                                <div className={`${reservationOne?.construction_reservation_progress === 3 ? "text-pointYellow font-semibold" : "text-mainBlack font-light"}`}>
                                    {reservationOne?.construction_reservation_progress_name}
                                </div>
                            </div>
                            <hr />
                            <div className="content-line">
                                <div className="label-box">브랜드</div>
                                <div className="content-box">{reservationOne?.brand_kor_name}</div>
                            </div>
                            <hr />
                            <div className="content-line">
                                <div className="label-box">제품명</div>
                                <div className="content-box">{reservationOne?.product_name} {reservationOne?.color_name}</div>
                            </div>
                            <hr />
                            <div className="content-line">
                                <div className="label-box">수량</div>
                                <div className="content-box">{reservationOne?.construction_reservation_count}개</div>
                            </div>
                            <hr />
                            <div className="content-line">
                                <div className="label-box">천장높이</div>
                                <div className="content-box">{reservationOne?.construction_reservation_high_status_name}</div>
                            </div>
                            <hr />
                            <div className="content-line">
                                <div className="label-box">고객명</div>
                                <div className="content-box">{reservationOne?.construction_reservation_name}</div>
                            </div>
                            <hr />
                            <div className="content-line">
                                <div className="label-box">주소</div>
                                <div className="content-box">{reservationOne?.construction_reservation_address}</div>
                            </div>
                            {reservationOne?.construction_reservation_division === 3 &&
                                <>
                                    <hr />
                                    <div className="content-line">
                                        <div className="label-box">이전할 주소</div>
                                        <div className="content-box">{reservationOne?.construction_reservation_before_address}</div>
                                    </div>
                                </>
                            }
                            <hr />
                            <div className="content-line">
                                <div className="label-box">전화번호</div>
                                <div className="content-box">{reservationOne?.construction_reservation_phone_number}</div>
                            </div>
                            <hr />
                            <div className="content-line">
                                <div className="label-box">요청사항</div>
                                <div className="content-box">
                                    <div className="reservation-detail-request-item">
                                        {reservationOne?.construction_reservation_requests}
                                    </div>
                                </div>
                            </div>
                            <hr />
                            <div className="content-line">
                                <div className="label-box">구분</div>
                                <div className="content-box">{reservationOne?.construction_reservation_division_name}</div>
                            </div>
                            <hr />
                            <div className="content-line">
                                <div className="label-box">전체 평수</div>
                                <div className="content-box">{reservationOne?.construction_reservation_square_meter_name}</div>
                            </div>
                            <hr />
                            <div className="content-line">
                                <div className="label-box">설치장소</div>
                                <div className="content-box">{reservationOne?.construction_reservation_space_name}</div>
                            </div>
                            <hr />
                            <div className="content-line">
                                <div className="label-box">시공 희망일</div>
                                <div className="content-box">{get_day_timestamp(reservationOne?.construction_reservation_reservationTime).year_month_day} {reservationOne?.construction_reservation_time_name}</div>
                            </div>
                            {reservationOne?.construction_reservation_schedule_status_name &&
                                <>
                                    <hr />
                                    <div className="content-line">
                                        <div className="label-box">해피콜 여부</div>
                                        <div className="content-box">{reservationOne?.construction_reservation_schedule_status_name}</div>
                                    </div>
                                </>
                            }
                            <hr />
                            <div className="content-line">
                                <div className="label-box">확정 시공일</div>
                                <div className="content-box">{reservationOne?.construction_reservation_installation_date_format ? `${reservationOne?.construction_reservation_installation_date_format} ${reservationOne?.construction_reservation_installation_time_period}` : "-"}</div>
                            </div>
                            <hr />
                            <div className="content-line">
                                <div className="label-box">예상견적</div>
                                <div className="content-box">{reservationOne?.construction_reservation_pay.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")} AP</div>
                            </div>
                        </S.SectionBorderContainer>
                        <div>
                            <div className="image-label-box">
                                <div className="image-label flex items-center justify-between">
                                    <span>현장 사진</span>
                                    {canEditSite && !siteEditMode &&
                                        <button type="button" className="text-sm font-normal underline" onClick={startSiteEdit}>사진 수정</button>
                                    }
                                </div>
                            </div>
                            {siteEditMode &&
                                <div>
                                    <S.PhotoBox $gridColumn={4}>
                                        {siteKeep.map((url, idx) =>
                                            <div className="prev-item" key={`keep-${url}`} onClick={() => setSiteKeep(siteKeep.filter((_, i) => i !== idx))}>
                                                <img className="prev-img" src={url} alt="" />
                                                <div className="prev-hover">삭제</div>
                                            </div>
                                        )}
                                        {siteNewFiles.map((file, idx) =>
                                            <div className="prev-item" key={`new-${idx}-${file.name}`} onClick={() => setSiteNewFiles(siteNewFiles.filter((_, i) => i !== idx))}>
                                                <img className="prev-img" src={siteNewPreviews[idx]} alt="" />
                                                <div className="prev-hover">삭제</div>
                                            </div>
                                        )}
                                        {Array.from({ length: Math.max(0, SITE_PHOTO_MAX - siteActiveCount) }).map((_, idx) =>
                                            <div key={`add-${idx}`}>
                                                <input type="file" id={`site_photo_${idx}`} name="site_files" accept=".png, .jpg, .jpeg, .webp, .gif .heif" onChange={addSiteFile} />
                                                <label htmlFor={`site_photo_${idx}`}>
                                                    <div className="photo-item">+</div>
                                                </label>
                                            </div>
                                        )}
                                    </S.PhotoBox>
                                    <div className="mt-2 text-sm">
                                        <span>{siteActiveCount} / {SITE_PHOTO_MAX}장 ({SITE_PHOTO_MIN}장 이상)</span>
                                        {siteActiveCount < SITE_PHOTO_MIN && <span className="alert-text"> -현장사진을 2장 이상 추가해주세요.</span>}
                                    </div>
                                    <div className="flex justify-center mt-4">
                                        <S.EmptyRoundedButton
                                            $width={140} $btnSelect={false}
                                            style={{backgroundColor : lightGray02, color : mainBlack}}
                                            disabled={siteSaving}
                                            onClick={cancelSiteEdit}
                                        >
                                            취소
                                        </S.EmptyRoundedButton>
                                        <S.EmptyRoundedButton
                                            $width={140} $btnSelect={false}
                                            style={{backgroundColor : mainBlack, color : mainWhite}}
                                            disabled={siteSaving}
                                            onClick={saveSitePhotos}
                                        >
                                            저장
                                        </S.EmptyRoundedButton>
                                    </div>
                                </div>
                            }
                            {!siteEditMode &&
                            <div
                                className="image-box"
                                onClick={(e: React.MouseEvent<HTMLElement>) => {
                                    if (!(e.target instanceof HTMLElement)) return;
                                    const element = e.target as HTMLElement;
                                    const index = Number(e.target.dataset.index);
                                    setImageCategory(1);
                                    if (index > siteImageList.length-1) return;
                                    if (element.tagName === "IMG") {
                                        setModal(true);
                                        setBigImageSRC(siteImageList[index]);
                                        setBigImageIndex(index);
                                    }
                                }}
                            >
                                <div>
                                    <img data-index={0} src={siteImageList.length >= 1 ? reservationOne?.construction_reservation_site_img_1 : no_image} alt="" />
                                </div>
                                <div>
                                    <img data-index={1} src={siteImageList.length >= 2 ? reservationOne?.construction_reservation_site_img_2 : no_image} alt="" />
                                </div>
                                <div>
                                    <img data-index={2} src={siteImageList.length >= 3 ? reservationOne?.construction_reservation_site_img_3 : no_image} alt="" />
                                </div>
                                <div>
                                    <img data-index={3} src={siteImageList.length >= 4 ? reservationOne?.construction_reservation_site_img_4 : no_image} alt="" />
                                </div>
                            </div>
                            }
                        </div>
                        <div>
                            {/* TODO: 이것도 나중에 이미지 생기면 아예 div 나눠서 사진있을 땐 클릭 시 확대해서 보여줄 수 있도록 */}
                            {reservationOne?.construction_reservation_progress === 4 &&
                            <>
                                <div className="image-label-box">
                                    <div className="image-label">시공 결과 사진</div>
                                </div>
                                <div className="image-box" onClick={(e: React.MouseEvent<HTMLElement>) => {
                                    if(!(e.target instanceof HTMLElement)) return;
                                    const element = e.target as HTMLElement;
                                    const index = Number(e.target.dataset.index);
                                    setImageCategory(2);
                                    if (index > imageList.length-1) return;
                                    if(element.tagName === "IMG") {
                                        setModal(true);
                                        setBigImageSRC(imageList[index]);
                                        setBigImageIndex(index);
                                    }
                                }}>
                                    <div>
                                        <img
                                            data-index={0}
                                            src={
                                                (reservationOne.construction_reservation_result_picture1 !== null &&
                                                reservationOne.construction_reservation_result_picture1 !== "") ?
                                                reservationOne?.construction_reservation_result_picture1 : no_image
                                            }
                                            alt=""
                                        />
                                    </div>
                                    <div>
                                        <img
                                            data-index={1}
                                            src={
                                                (reservationOne.construction_reservation_result_picture2 !== null &&
                                                reservationOne.construction_reservation_result_picture2 !== "") ?
                                                reservationOne?.construction_reservation_result_picture2 : no_image
                                            }
                                            alt=""
                                        />
                                    </div>
                                    <div>
                                        <img
                                            data-index={2}
                                            src={
                                                (reservationOne.construction_reservation_result_picture3 !== null &&
                                                reservationOne.construction_reservation_result_picture3 !== "") ?
                                                reservationOne?.construction_reservation_result_picture3 : no_image
                                            }
                                            alt=""
                                        />
                                    </div>
                                    <div>
                                        <img
                                            data-index={3}
                                            src={
                                                (reservationOne.construction_reservation_result_picture4 !== null &&
                                                reservationOne.construction_reservation_result_picture4 !== "") ?
                                                reservationOne?.construction_reservation_result_picture4 : no_image
                                            }
                                            alt=""
                                        />
                                    </div>
                                </div>
                            </>
                            }
                        </div>
                    </div>
                </S.ReservationSelectOneContainer>
                {modal &&
                <S.SelectOnePortfolioModal onClick={(e: React.MouseEvent<HTMLDivElement>) => {
                    if(!(e.target instanceof HTMLImageElement)) {
                        setModal(false);
                    }
                }}>
                    <div className="flex-box">
                        <div className="close-box right-[12%] 2xl:right-[25%]">
                            <img src={closeIcon} alt="" onClick={() => setModal(false)} />
                        </div>

                        <div className="arrow-box left-[12%] 2xl:left-[25%]">
                            {(siteImageList.length > 1 && imageCategory === 1) &&
                                <button onClick={() => {
                                    if(bigImageIndex !== 0) {
                                        setBigImageIndex(bigImageIndex-1);
                                        setBigImageSRC(siteImageList[bigImageIndex-1]);
                                    } else if (bigImageIndex === 0) {
                                        setBigImageIndex(siteImageList.length-1);
                                        setBigImageSRC(siteImageList[siteImageList.length-1]);
                                    }
                                }}>
                                    <img src={leftArrow} alt="" />
                                </button>
                            }
                            {(imageList.length > 1 && imageCategory === 2) &&
                                <button onClick={() => {
                                    if(bigImageIndex !== 0) {
                                        setBigImageIndex(bigImageIndex-1);
                                        setBigImageSRC(imageList[bigImageIndex-1]);
                                    } else if (bigImageIndex === 0) {
                                        setBigImageIndex(imageList.length-1);
                                        setBigImageSRC(imageList[imageList.length-1]);
                                    }
                                }}>
                                    <img src={leftArrow} alt="" />
                                </button>
                            }
                        </div>
                        
                        <div className="modal-image-box">
                            <img src={bigImageSRC} alt="" />
                        </div>

                        <div className="arrow-box right-[12%] 2xl:right-[25%]">
                            {(siteImageList.length > 1 && imageCategory === 1) &&
                                <button onClick={() => {
                                    if(bigImageIndex+1 < siteImageList.length) {
                                        setBigImageIndex(bigImageIndex+1);
                                        setBigImageSRC(siteImageList[bigImageIndex+1]);
                                    } else {
                                        setBigImageIndex(0);
                                        setBigImageSRC(siteImageList[0]);
                                    }
                                }}>
                                    <img src={rightArrow} alt="" />
                                </button>
                            }
                            {(imageList.length > 1 && imageCategory === 2) &&
                                <button onClick={() => {
                                    if(bigImageIndex+1 < imageList.length) {
                                        setBigImageIndex(bigImageIndex+1);
                                        setBigImageSRC(imageList[bigImageIndex+1]);
                                    } else {
                                        setBigImageIndex(0);
                                        setBigImageSRC(imageList[0]);
                                    }
                                }}>
                                    <img src={rightArrow} alt="" />
                                </button>
                            }
                        </div>
                    </div>

                    <div className="index-box">
                        {bigImageIndex+1} / {imageCategory === 1 ? siteImageList.length : imageList.length}
                    </div>

                </S.SelectOnePortfolioModal>
            }
                <S.SectionContent>
                    <div className="section-flex-box w-[100%] justify-center">
                        {reservationOne?.construction_reservation_progress !== 4 && reservationOne?.construction_reservation_progress !== 5 &&
                            <S.EmptyRoundedButton 
                                onClick={() => {
                                    if(!window.confirm('예약을 취소하시겠습니까?')) return;
                                    if(reservationOne?.construction_reservation_ID) {
                                        let reservation_ID = reservationOne?.construction_reservation_ID;
                                        cancel_reservation_one(
                                            reservation_ID,
                                            customerData.customer_ID,
                                            reservationOne?.construction_reservation_progress
                                        ).then(result => {
                                            if(result === 1) {
                                                update_nav();
                                                navigate('/main');
                                                alert('예약이 취소되었습니다.');
                                            } else if(result === 3) {
                                                alert('출고가 승인된 예약은 취소할 수 없습니다. 본사에 문의해 주세요.');
                                            } else {
                                                alert('알 수 없는 오류입니다.');
                                            };
                                        })
                                    }
                                }}
                                $width={280} $btnSelect={false}
                                style={{backgroundColor : lightGray02, color : mainBlack}}
                            >
                                취소하기
                            </S.EmptyRoundedButton>
                        }
                        {reservationOne?.construction_reservation_progress === 2 &&
                            <S.EmptyRoundedButton 
                                onClick={() => {
                                    let sec = Math.floor((Math.random() * 3) * 100) + 50;
                                    dispatch(reduxOnSpinner('잠시만 기다려주세요'));
                                    setTimeout(() => {
                                        dispatch(reduxOffSpinner());
                                        navigate('/payment', {state : reservationOne});
                                    }, sec);
                                }}
                                $width={280} $btnSelect={false}
                                style={{backgroundColor : mainBlack, color : mainWhite}}
                            >
                                결제하기
                            </S.EmptyRoundedButton>
                        }
                    </div>
                </S.SectionContent>
                
                <U.BreakLine $height={60} />
                
            </S.SectionWidth>
        </S.SectionContainer>
    )
};

export default ReservationSelectOne;